import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import ReviewRequestsSection from '@/components/dashboard/sections/ReviewRequestsSection';
import DraftReviewsSection from '@/components/dashboard/sections/DraftReviewsSection';
import PublishedReviewsSection from '@/components/dashboard/sections/PublishedReviewsSection';
import CommentsSection from '@/components/dashboard/sections/CommentsSection';
import SharedWithMeSection from '@/components/dashboard/sections/SharedWithMeSection';

/**
 * Secondary surface: the review chores, on demand. Reuses the existing
 * dashboard sections unchanged — only the framing changes.
 */
const ReviewDesk = () => (
  <section id="review-desk" className="mb-12 scroll-mt-24">
    <h2 className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-4">
      Review desk
    </h2>
    <div className="rounded-xl border border-border/60 bg-card px-5">
      <Accordion type="single" collapsible>
        <AccordionItem value="requests">
          <AccordionTrigger className="text-sm">Review requests</AccordionTrigger>
          <AccordionContent className="pb-6">
            <ReviewRequestsSection />
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="shared">
          <AccordionTrigger className="text-sm">Shared with me</AccordionTrigger>
          <AccordionContent className="pb-6">
            <SharedWithMeSection />
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="drafts">
          <AccordionTrigger className="text-sm">My unfinished reviews</AccordionTrigger>
          <AccordionContent className="pb-6">
            <DraftReviewsSection />
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="published">
          <AccordionTrigger className="text-sm">My published reviews</AccordionTrigger>
          <AccordionContent className="pb-6">
            <PublishedReviewsSection />
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="comments" className="border-b-0">
          <AccordionTrigger className="text-sm">Comments</AccordionTrigger>
          <AccordionContent className="pb-6">
            <CommentsSection />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  </section>
);

export default ReviewDesk;
